import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsHoming(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsHoming(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsHoming - ', e);
                throw e;
            });
    };
}
export { getLogsHoming };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsHoming/actions.js